import React from "react";
import { Checkbox as PasteCheckBox } from "@twilio-paste/core";

import { Field } from "../../store/definitions";

type CheckboxProps = {
    field: Field;
    onChange?: (newValue: string) => void;
    value?: string;
};

export const CheckBox = ({ field, onChange, value }: CheckboxProps) => {
    const { name, label, required } = field;

    const checkedValue = React.useMemo(() => /true/.test(value ?? "false"), [value]);

    return (
        <PasteCheckBox
            checked={checkedValue}
            id={name}
            name={name}
            onChange={(e) => onChange?.(e.target.checked ? "true" : "false")}
            required={required}
        >
            {label}
        </PasteCheckBox>
    );
};
